import { supportedLocales, type Locale } from './types';

const LOCALE_STORAGE_KEY = 'myhoreca-pay.locale';
const DEFAULT_LOCALE: Locale = 'en';

function isSupportedLocale(value: string | null): value is Locale {
  return supportedLocales.includes(value as Locale);
}

/** Map browser language tags (ru-RU, id-ID, en-US, …) to a supported app locale. */
export function detectBrowserLocale(languages: readonly string[] = []): Locale {
  for (const raw of languages) {
    const tag = raw.trim().toLowerCase();
    if (!tag) continue;
    const primary = tag.split('-')[0] ?? tag;
    if (isSupportedLocale(primary)) {
      return primary;
    }
  }
  return DEFAULT_LOCALE;
}

export function readLocale(): Locale {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE;
  }
  const persisted = window.localStorage.getItem(LOCALE_STORAGE_KEY);
  if (isSupportedLocale(persisted)) {
    return persisted;
  }
  return detectBrowserLocale(window.navigator.languages ?? [window.navigator.language]);
}

export function persistLocale(locale: Locale): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
}

export { LOCALE_STORAGE_KEY, DEFAULT_LOCALE, isSupportedLocale };
